import React from 'react';
import { RouterConfig } from '../../config/router';
import { UnderOverMenu } from '../../components/UnderOverMenu';

const allPageTile = [
  {
    title: '2.5',
    over: RouterConfig.OffsideOverTwo,
    under: RouterConfig.OffsideUnderTwo,
  },
  {
    title: '3.5',
    over: RouterConfig.OffsideOverThree,
    under: RouterConfig.OffsideUnderThree,
  },
  {
    title: '4.5',
    over: RouterConfig.OffsideOverFour,
    under: RouterConfig.OffsideUnderFour,
  },
];

export default function OffsideTile() {
  return <UnderOverMenu menu={allPageTile} title="Wybór Spalonych" />;
}
